module.exports = __webpack_public_path__ + "media/images/dashboard/payment/ae-card-abcb782dd608cab65a32df5b78118344.jpeg";